// src/ops/types/ApiKeys.ts
var ApiKeyService = /* @__PURE__ */ ((ApiKeyService2) => {
  ApiKeyService2["Ai"] = "ai";
  ApiKeyService2["Booking"] = "booking";
  ApiKeyService2["Main"] = "main";
  ApiKeyService2["Notifications"] = "notifications";
  ApiKeyService2["Payment"] = "payment";
  return ApiKeyService2;
})(ApiKeyService || {});

export {
  ApiKeyService
};
